
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import LazyImage from "@src/components/LazyImage";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import {
  mediaNakameguroSekiyaInsideImage,
  mediaNakameguroSekiyaLineImage,
  mediaNakameguroSekiyaNapolitanImage,
} from "@src/constants/images";
export const meta = {
  path: "/media/nakameguro/sekiya",
  title: "【中目黒の行列店】関谷スパゲティの名物ナポリタンに迫る",
  description: "中目黒から徒歩3分に位置する関谷スパゲティについてご紹介します。１０種類以上あるナポリタンの魅力の魅せられて、平日は回転まえから行列ができているお店。今回は、お店の雰囲気、食事、そして行列情報についてわかりやすくまとめています。関谷スパゲティにお越しの方は、一読ください。",
  topImg: mediaNakameguroSekiyaNapolitanImage,
  author: murakamiMasanori,
  tags: ["中目黒", "有名店", "おしゃれな内装", "人気店", "お店の紹介", "1人メシ", "ナポリタン", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`中目黒から徒歩 3 分歩くと、まるでカフェのように見えるナポリタンのお店が「関谷スパゲティ」です。`}</p>
    <p>{`その行列を写真にとる通行人も多く、一体どの時間に並べばいいのかについてご紹介をしております。また、多様なナポリタンも紹介します。`}</p>
    <h2>{`関谷スパゲティとは`}</h2>
    <InstaImage postId="CFbj2tGBZFs" mdxType="InstaImage" />
    <p>{`中目黒駅の目の前の大通りを左にまっすぐ 3 分歩いたところに位置するナポリタンの名店。
食べログの評価は 3.6 を超え、開店前の 11:30 頃には 10 人以上の行列ができていることが日常茶飯事です。
本日はそんな名店についてご紹介をします。`}</p>
    <h3>{`カフェのような雰囲気のお店`}</h3>
    <LazyImage img={mediaNakameguroSekiyaInsideImage} mdxType="LazyImage" />
    <p>{`店外は白の外壁にビビッドカラーの黄色のテーブルなのが特徴的ですぐに発見することができます。
店内はカウンター席とテーブル席が 10 席ずつあり、メニューの看板やキッチンの様子が見れるようになっています。`}</p>
    <h3>{`明るい店員`}</h3>
    <p>{`オープンの席の案内から会計まで、常に明るく接客してくれるのが特徴です。
店員の方の接客は、料理の点数にも影響を与えるので、非常に重要なポイントですよね。`}</p>
    <hr></hr>
    <h2>{`豊富な種類のナポリタン`}</h2>
    <InstaImage postId="CFzJYQJgGUq" mdxType="InstaImage" />
    <p>{`ナポリタンはレギュラーメニューが 10 種類近くあり、季節限定のメニューが数種類あります。
定番物だけじゃなく、その日の気分に合わせて食べたいものを選択できるのが関谷スパゲティの良いところです。`}</p>
    <h3>{`ポルチーニ茸のナポリタン`}</h3>
    <LazyImage img={mediaNakameguroSekiyaNapolitanImage} mdxType="LazyImage" />
    <p>{`僕が食べたのはこちらのポルチーニ茸のナポリタン。
クリームで煮付けがされたソースが、ポルチーニの豊かな香りと混ざり合い、どしっとした味わい。
普通盛りでお腹いっぱいになるくらいの量があります。`}</p>
    <h3>{`豊富なトッピング`}</h3>
    <p>{`ナポリタンにも味付けがされているのですが、全ての席にトッピングが用意されています
チーズ、塩胡椒、さらにはラー油などの調味料があるので、食事の後半にトッピングしていろんな味付けを楽しんでください。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <LazyImage img={mediaNakameguroSekiyaLineImage} mdxType="LazyImage" />
    <p>{`食べログの評価や立地条件から、行列ができるのは必須となっています。
特に、休日のランチのゴールデンタイムは注意が必要です。`}</p>
    <p>{`平日と休日問わず、11:30~12:00 か、12:30 頃に訪れると良いでしょう。
ちょうど食事を終えた方が回転するのがその時間帯になるので、その時間帯を狙って伺いましょう。`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;